import React from 'react';

import { Container } from '@mui/material';

import classes from './NgzScholasticCustomerSelfSetup.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { getRouteParam } from '../../../shared/utils/angularUtils';
import { CompleteCreateInfo } from './containers/CompleteCreateInfo/CompleteCreateInfo';
import { useStepper } from '../../../shared/hooks/useStepper';
import { CreateScholasticCustomer } from './containers/CreateScholasticCustomer/CreateScholasticCustomer';
import { NgzPageNotFound } from '../../../shared/containers/NgzPageNotFound/NgzPageNotFound';

const NgzScholasticCustomerSelfSetup = () => {
  const { activeStep, goToNextStep } = useStepper(0);

  const entityId = getRouteParam('sub1');
  const token = getRouteParam('sub2');

  if (!entityId || !token) {
    return <NgzPageNotFound />;
  }

  const stepsComponent = [
    <CreateScholasticCustomer
      key="create-scholastic-customer"
      entityId={entityId}
      token={token}
      goToNextStep={goToNextStep}
    />,
    <CompleteCreateInfo key="complete-create-info" />,
  ];

  return (
    <div className={classes.background}>
      <Container className={classes.container}>{stepsComponent[activeStep]}</Container>
    </div>
  );
};

angularizeWithProviders(
  NgzScholasticCustomerSelfSetup,
  'ngzScholasticCustomerSelfSetup',
  {},
);

export { NgzScholasticCustomerSelfSetup };
